<form
  class="form-container"
  [formGroup]="standardTeamForm"
  (ngSubmit)="onSubmit()"
>
  <mat-form-field>
    <mat-label>{{ 'Teams Name' | translate }}</mat-label>
    <input matInput id="name" type="text" formControlName="name" />
    <mat-error>
      {{ errorMessage | translate }}
    </mat-error>
  </mat-form-field>
  <mat-form-field>
    <mat-label>MailNickname:</mat-label>
    <input
      matInput
      id="mailNickname"
      type="text"
      formControlName="mailNickname"
    />
  </mat-form-field>
  <div class="inline-info">
    <mat-form-field class="inline-form">
      <mat-label>{{ 'Category' | translate }}</mat-label>
      <mat-select id="category" formControlName="category">
        @for (category of categories; track category.id) {
          <mat-option [value]="category.name">{{
            category.name | translate | titlecase
          }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <i
      ><img
        class="infobutton"
        src="../../../assets/icons/Information-Circle--Streamline-Ultimate.svg"
        alt="Info"
        [matTooltip]="'LIFECYCLE_INFO' | translate"
        matTooltipClass="newline-matTooltip"
    /></i>
  </div>
  <div class="inline-info">
    <mat-form-field class="inline-form">
      <mat-label>{{ 'Primary Owner' | translate }}</mat-label>
      <input
        matInput
        id="primaryOwner"
        type="text"
        formControlName="primaryOwner"
      />
    </mat-form-field>
    <i
      ><img
        class="infobutton"
        src="../../../assets/icons/Information-Circle--Streamline-Ultimate.svg"
        alt="Info"
        [matTooltip]="'PRIMARY_OWNER_INFO' | translate"
        matTooltipClass="newline-matTooltip"
    /></i>
  </div>
  <div class="inline-info">
    <mat-form-field class="inline-form">
      <mat-label>{{ 'Secondary Owner' | translate }}</mat-label>
      <input
        type="text"
        matInput
        [placeholder]="'Search for a secondary owner' | translate"
        [formControlName]="'secondaryOwner' | translate"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayUserFn"
        (optionSelected)="onSecondaryOwnerSelected($event)"
      >
        @for (person of filteredPeople | async; track person.id) {
          <mat-option [value]="person">
            {{ person.displayName }} ({{ person.userPrincipalName }})
          </mat-option>
        }
      </mat-autocomplete>
      <mat-error>
        {{ 'Please select a valid user from the dropdown list' | translate }}
      </mat-error>
    </mat-form-field>
    <i
      ><img
        class="infobutton"
        src="../../../assets/icons/Information-Circle--Streamline-Ultimate.svg"
        alt="Info"
        [matTooltip]="'SECONDARY_OWNER_INFO' | translate"
        matTooltipClass="newline-matTooltip"
    /></i>
  </div>
  <div class="inline-info">
    <mat-form-field class="inline-form">
      <mat-label>{{ 'Visibility' | translate }}</mat-label>
      <mat-select id="visibility" formControlName="visibility">
        <mat-option value="private">{{ 'Private' | translate }}</mat-option>
        <mat-option value="public">{{ 'Public' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
    <i
      ><img
        class="infobutton"
        src="../../../assets/icons/Information-Circle--Streamline-Ultimate.svg"
        alt="Info"
        [matTooltip]="'VISIBILITY_INFO' | translate"
        matTooltipClass="newline-matTooltip"
    /></i>
  </div>
  <mat-form-field>
    <mat-label>{{ 'Department' | translate }}</mat-label>
    <mat-select id="department" formControlName="department">
      @for (department of departments; track department.id) {
        <mat-option [value]="department.name">{{
          department.name | translate
        }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <hr />
  <div class="form-footer">
    <div class="form-nav"></div>
    <div class="submit">
      <button
        mat-flat-button
        color="primary"
        [disabled]="!standardTeamForm.valid"
      >
        {{ 'Send' | translate }}
      </button>
    </div>
  </div>
</form>
